import clsx from 'clsx';
import type { CardChildProps, CardProps } from './Card.types';

const CardShell = ({
  border,
  children,
  fill = 'bg-white',
  isRounded = true,
  isElevated = true,
  isFullBleed = false,
  hasBorder = false,
  ...props
}: CardProps) => {
  const styleCard = `relative ${fill} print:border print:border-black`;
  const styleRounded = 'rounded-8';
  const styleElevated = 'shadow-elevation-high print:shadow-none';
  const styleBorder = 'border-2';
  const styleFullBleed = 'p-0';
  const stylePadded = 'p-16px';

  const cardStyles = clsx(styleCard, border && `${border}`, {
    [styleRounded]: isRounded,
    [styleElevated]: isElevated,
    [styleBorder]: hasBorder,
    [styleFullBleed]: isFullBleed,
    [stylePadded]: !isFullBleed
  });

  return (
    <div className={cardStyles} {...props}>
      {children}
    </div>
  );
};

const CardShellImage = ({ children }: CardChildProps) => {
  return <div className="-mx-16px -mt-16px mb-16px">{children}</div>;
};

const CardShellContent = ({ children }: CardChildProps) => {
  return <div>{children}</div>;
};

const CardShellCTA = ({ children }: CardChildProps) => {
  return <div className="text-right mt-16px">{children}</div>;
};

export { CardShell, CardShellContent, CardShellCTA, CardShellImage };
